import React from 'react';
import styled from 'styled-components';

import FieldCell from 'components/lib/form/FieldCell';
import Form from 'components/lib/form/Form';
import ToggleField from 'components/lib/form/ToggleField';
import FlexContainer from 'components/lib/ui/FlexContainer';
import LoadingSpinner from 'components/lib/ui/LoadingSpinner';

import useProfileFlag from 'common/lib/hooks/users/useProfileFlag';
import { color, radius, spacing } from 'common/lib/theme/dynamic';

import { REFERRALS } from 'common/constants/copy';

const FLAG_NAME = 'hasHiddenReferralProgramPrompts';
const FIELD_NAME = 'showPrompts'; // The opposite of the flag

const SpinnerContainer = styled(FlexContainer).attrs({ justifyCenter: true })`
  padding: ${spacing.default};
  border: 1px solid ${color.grayFocus};
  border-radius: ${radius.small};
  margin: 0 ${spacing.xlarge} ${spacing.xlarge} ${spacing.xlarge};
`;

type Props = {
  className?: string;
};

export const ReferralsPromptsToggle = ({ className }: Props) => {
  const [
    hasHiddenReferralProgramPrompts,
    setHasHiddenReferralProgramPrompts,
    isLoadingHasHiddenReferralProgramPrompts,
  ] = useProfileFlag(FLAG_NAME);

  return isLoadingHasHiddenReferralProgramPrompts ? (
    <SpinnerContainer>
      <LoadingSpinner />
    </SpinnerContainer>
  ) : (
    <Form
      className={className}
      initialValues={{
        [FIELD_NAME]: !hasHiddenReferralProgramPrompts,
      }}
      enableReinitialize
      onSubmit={(values) => {
        setHasHiddenReferralProgramPrompts(!values[FIELD_NAME]);
      }}
      submitOnChange
    >
      <FieldCell
        subtitle={REFERRALS.SHOW_PROMO_SETTING_SUBTITLE}
        rightAccessory={<ToggleField name={FIELD_NAME} hideLabel />}
      />
    </Form>
  );
};
